import {Box, Overlay, Transition} from '@mantine/core'
import {Logo} from '../logo/Logo.tsx'

type Props = {
  onLogoAnimationEnded?: () => void
  loading: boolean
}

export const FullscreenLoader = ({onLogoAnimationEnded, loading}: Props) => {
  return (
    <Transition mounted={loading} transition='fade' duration={400} timingFunction='ease'>
      {(transitionStyles) => (
        <Box pos={'fixed'} inset={0}>
          <Overlay
            zIndex={1000000}
            backgroundOpacity={0}
            radius={'xl'}
            blur={25}
            style={{
              ...transitionStyles,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Logo animate={true} onMainAnimationEnded={onLogoAnimationEnded} />
          </Overlay>
        </Box>
      )}
    </Transition>
  )
}
